import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SecurityAntiPhishingModalComponent } from "./components/anti-phishing-modal/anti-phishing-modal.component";
import { ReactiveFormsModule } from "@angular/forms";
import { Security2faModule } from "../security-2fa-modal/security-2fa.module";
import { AntiPhishingForceModalComponent } from "./components/anti-phishing-force-modal/anti-phishing-force-modal.component";

const components = [SecurityAntiPhishingModalComponent, AntiPhishingForceModalComponent];

@NgModule({
	imports: [CoreModule, ReactiveFormsModule, Security2faModule],
	declarations: [...components],
	exports: [...components]
})
export class SecurityAntiPhishingModule {}
